
export default function Services() {
  const included = [
    { icon: 'ri-flight-takeoff-line', text: 'Vé máy bay VN → Hawaii (nếu chọn gói từ Việt Nam)' },
    { icon: 'ri-plane-line', text: 'Vé liên đảo Oahu - Đảo Lớn - Maui - Oahu' },
    { icon: 'ri-hotel-line', text: 'Khách sạn 4 sao & AirBnB tiện nghi' },
    { icon: 'ri-ticket-line', text: 'Vé tham quan các điểm du lịch' },
    { icon: 'ri-car-line', text: 'Xe tự lái 7-8 chỗ (4-5 khách/xe)' },
    { icon: 'ri-restaurant-line', text: 'Ăn sáng + tối hằng ngày' },
    { icon: 'ri-cup-line', text: 'Nước uống hằng ngày' },
    { icon: 'ri-music-2-line', text: 'Show Polynesian văn hóa' },
    { icon: 'ri-shield-check-line', text: 'Bảo hiểm xe cơ bản (nhóm)' }
  ];

  const notIncluded = [
    { icon: 'ri-goblet-line', text: 'Đồ uống có cồn & chi phí cá nhân' },
    { icon: 'ri-exchange-line', text: 'Phí đổi vé máy bay' },
    { icon: 'ri-passport-line', text: 'Visa Mỹ (hỗ trợ tư vấn miễn phí)' },
    { icon: 'ri-user-line', text: 'Hướng dẫn viên từ Việt Nam' },
    { icon: 'ri-gas-station-line', text: 'Xăng xe & phí cầu đường' },
    { icon: 'ri-shield-star-line', text: 'Nâng cấp bảo hiểm xe (tùy chọn)' }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Dịch vụ <span className="text-blue-600">bao gồm</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Chi tiết những gì có trong gói tour của bạn
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {/* Included Services */}
          <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-3xl p-8 border-2 border-green-200">
            <div className="flex items-center mb-6">
              <div className="w-14 h-14 bg-green-500 rounded-xl flex items-center justify-center mr-4">
                <i className="ri-checkbox-circle-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Bao gồm trong tour</h3>
            </div>
            <div className="space-y-4">
              {included.map((item, index) => (
                <div key={index} className="flex items-start bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                    <i className={`${item.icon} text-green-600 text-xl`}></i>
                  </div>
                  <p className="text-gray-700 leading-relaxed pt-1">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Not Included Services */}
          <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-3xl p-8 border-2 border-orange-200">
            <div className="flex items-center mb-6">
              <div className="w-14 h-14 bg-orange-500 rounded-xl flex items-center justify-center mr-4">
                <i className="ri-information-line text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Không bao gồm</h3>
            </div>
            <div className="space-y-4">
              {notIncluded.map((item, index) => (
                <div key={index} className="flex items-start bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                    <i className={`${item.icon} text-orange-600 text-xl`}></i>
                  </div>
                  <p className="text-gray-700 leading-relaxed pt-1">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="#final-cta"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-teal-500 text-white rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Xem chi tiết dịch vụ
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
